const swiperHomeShop = new Swiper(".swiper-home-shop", {
  loop: true,
  slidesPerView: "auto",
  slidesPerGroup: 1,
  spaceBetween: 18,

  breakpoints: {
    768: {
      spaceBetween: 24,
    },
  },

  navigation: {
    nextEl: ".swiper-next",
    prevEl: ".swiper-prev",
  },
});
